"use client";

import { ComponentProps } from "react";

import { StockStatus } from "@/services/product/product.config";
import { ProductStockStatus } from "../utils/getProductStockStatus";
import type { CartProduct, PurchaseProduct } from "../utils/toCartProduct";
import ProductForm from "./ProductForm";
import ProductMonitoring from "./ProductMonitoring";

const emptyLightsourceCarts: CartProduct[] = [];

type ProductCartProps = {
  purchase: PurchaseProduct;
  countryCode: string;
  siteLocale: string;
  stockStatus: ProductStockStatus;
  lightsourceCarts?: CartProduct[];
  lightsourceParam?: string | null;
  className?: string;
} & ComponentProps<"div">;

export default function ProductCart({
  purchase,
  countryCode,
  siteLocale,
  stockStatus,
  lightsourceCarts = emptyLightsourceCarts,
  lightsourceParam = null,
  className,
  children,
  ...props
}: ProductCartProps) {
  if (stockStatus.code === StockStatus.SoldOut) {
    return children;
  }

  if (!stockStatus.purchasable) {
    return (
      <ProductMonitoring
        productKey={purchase.key}
        variantKey={purchase.partNo}
        className={className}
        {...props}
      >
        {children}
      </ProductMonitoring>
    );
  }

  return (
    <ProductForm
      purchase={purchase}
      countryCode={countryCode}
      siteLocale={siteLocale}
      lightsourceCarts={lightsourceCarts}
      lightsourceParam={lightsourceParam}
      className={className}
      {...props}
    >
      {children}
    </ProductForm>
  );
}
